import { Box, type BoxProps, Grid, GridItem } from "@drone-js/core";
import type { FunctionComponent, PropsWithChildren } from "react";

interface PartnerMarketingLayoutProps extends BoxProps, PropsWithChildren {
    col: 8 | 10;
}

export const PartnerMarketingLayout: FunctionComponent<PartnerMarketingLayoutProps> = ({ col, children, ...rest }) => {
    const maxWidth = col === 8 ? "848px" : "1064px";
    const emptyGridItemLgSize = col === 8 ? 2 : 1;

    return (
        <Box width="100%" mx="auto" px="16" qM={{ px: "24" }} qL={{ px: "0" }} {...rest}>
            <Grid fluid spacing="0">
                <GridItem xl={emptyGridItemLgSize} />
                <GridItem xl={col} md={12} sm={12}>
                    <Box display="flex" justifyContent="center">
                        <Box maxWidth={maxWidth} width="100%">
                            {children}
                        </Box>
                    </Box>
                </GridItem>
            </Grid>
        </Box>
    );
};
